// ─── Brand ────────────────────────────────────────────────────────────────────

/** Change this one value to rename the product everywhere in the UI. */
export const APP_NAME = "Sentrilog";

/** Product tagline — shown on the login page, landing page hero, and footer. */
export const APP_TAGLINE = "Never miss a renewal. Never pay a fine.";

/** Support / contact email address */
export const SUPPORT_EMAIL = "hello@sentrilog.com";

// ─── Expiry status thresholds ─────────────────────────────────────────────────

/** Documents expiring within this many days are marked "High Risk" */
export const HIGH_RISK_DAYS = 7;

/** Documents expiring within this many days are marked "Upcoming" */
export const UPCOMING_DAYS = 30;

/** Days before expiry at which automated reminder emails are sent (descending) */
export const REMINDER_THRESHOLDS = [30, 7, 1] as const;

// ─── Date formatting ──────────────────────────────────────────────────────────

/** Displayed date format used throughout the table */
export const DATE_DISPLAY_FORMAT = "MMM dd, yyyy";

/** Locale used for human-readable date strings in toasts */
export const DATE_LOCALE = "en-US";

/** Options passed to `Date.toLocaleDateString` for toast messages */
export const DATE_LOCALE_OPTIONS: Intl.DateTimeFormatOptions = {
  month: "long",
  day: "numeric",
  year: "numeric",
};

// ─── Tailwind colour tokens ───────────────────────────────────────────────────
// Keep colours in one place so a design-token update touches a single file.

export const COLOR = {
  danger: "text-[#DC2626]",
  warning: "text-[#D97706]",
  safe: "text-[#15803D]",
  muted: "text-[#9CA3AF]",
  neutral: "text-[#374151]",
  subtle: "text-[#6B7280]",
} as const;

// ─── Card filter values ───────────────────────────────────────────────────────

export const CARD_FILTER_VALUES = [
  "high-risk",
  "upcoming",
  "needs-attention",
] as const;

// ─── Action column button ─────────────────────────────────────────────────────

/**
 * Base Tailwind classes for every contextual Action column button.
 * Mirrors the BulkActionBar button style: white background, grey border,
 * neutral text at rest; colour appears only on hover.
 */
export const ACTION_BTN_BASE =
  "inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium " +
  "bg-white border border-[#E5E7EB] text-[#374151] transition-colors whitespace-nowrap";

// ─── Toast durations (milliseconds) ──────────────────────────────────────────

export const TOAST = {
  short: 3000,
  normal: 4000,
  long: 5000,
} as const;

// ─── CSV import limits ────────────────────────────────────────────────────────
// Mirror the backend csvImport config so the UI validates before uploading.
// Override via CRA env vars (must be prefixed with REACT_APP_):
//   REACT_APP_CSV_MAX_FILE_SIZE_MB / REACT_APP_CSV_MAX_ROWS

/**
 * Maximum upload size in megabytes.
 * Env: REACT_APP_CSV_MAX_FILE_SIZE_MB  (default: 5)
 */
export const CSV_IMPORT_MAX_FILE_SIZE_MB: number =
  Number(process.env.REACT_APP_CSV_MAX_FILE_SIZE_MB) || 5;

/**
 * Maximum number of data rows (excluding header) per import.
 * Env: REACT_APP_CSV_MAX_ROWS  (default: 500)
 */
export const CSV_IMPORT_MAX_ROWS: number =
  Number(process.env.REACT_APP_CSV_MAX_ROWS) || 500;

// ─── CSV export ───────────────────────────────────────────────────────────────

export const CSV_FILENAME = "expiry-items.csv";
export const CSV_MIME = "text/csv";
export const CSV_HEADERS = ["Name", "Category", "Expiry Date", "Status"];
